<template>
  <div>
    <PageHeader
      :image="require('@/images/resultadoBanner.jpg')"
      ariaLabel="Pessoas correndo"
      :minHeight="421"
      title="Resultados"
    />
    <search-results />
    <div class="result-page" v-if="!loading">
      <div class="container result-page__section">
        <div class="row result-page__title">
          <div class="col-12 col-lg-11 offset-lg-1">
            Corrida Individual Masculina 5km
          </div>
        </div>
        <div v-for="result in m5" :key="result.COL_MF" class="row result-page__result">
          <div class="col-auto offset-lg-1">
            <img src="@/images/prize.svg" alt="">
          </div>
          <div class="col">
            <div class="result-page__subtitle">{{ result.COL_MF }}º Lugar</div>
            <div class="result-page__text">{{ result.NOME }}</div>
            <div class="result-page__small">Tempo Bruto: {{ result.TEMPO_BRUTO }}</div>
            <div class="result-page__small">Tempo Líquido: {{ result.TEMPO_LIQ }}</div>
          </div>
        </div>
      </div>
      <div class="container result-page__divider"></div>
      <div class="container result-page__section">
        <div class="row result-page__title">
          <div class="col-12 col-lg-11 offset-lg-1">
            Corrida Individual Feminina 5km
          </div>
        </div>
        <div v-for="result in f5" :key="result.COL_MF" class="row result-page__result">
          <div class="col-auto offset-lg-1">
            <img src="@/images/prize.svg" alt="">
          </div>
          <div class="col">
            <div class="result-page__subtitle">{{ result.COL_MF }}º Lugar</div>
            <div class="result-page__text">{{ result.NOME }}</div>
            <div class="result-page__small">Tempo Bruto: {{ result.TEMPO_BRUTO }}</div>
            <div class="result-page__small">Tempo Líquido: {{ result.TEMPO_LIQ }}</div>
          </div>
        </div>
      </div>
      <div class="container result-page__divider"></div>
      <div class="container result-page__section">
        <div class="row result-page__title">
          <div class="col-12 col-lg-11 offset-lg-1">
            Revezamento Duplo Misto 5km
          </div>
        </div>
        <div class="row result-page__result">
          <div class="col-auto offset-lg-1">
            <img src="@/images/prize.svg" alt="">
          </div>
          <div class="col">
            <div class="result-page__subtitle">1º Lugar</div>
            <div class="result-page__text">CARLOS ALBERTO/ANDREA DE SOUZA</div>
            <div class="result-page__small">Tempo Bruto: 00:22:46</div>
            <div class="result-page__small">Tempo Líquido: 00:22:41</div>
          </div>
        </div>
        <div class="row result-page__result">
          <div class="col-auto offset-lg-1">
            <img src="@/images/prize.svg" alt="">
          </div>
          <div class="col">
            <div class="result-page__subtitle">2º Lugar</div>
            <div class="result-page__text">ROBERTO ROSA/RENATA DE OLIVEIRA</div>
            <div class="result-page__small">Tempo Bruto: 00:22:54</div>
            <div class="result-page__small">Tempo Líquido: 00:22:54</div>
          </div>
        </div>
        <div class="row result-page__result">
          <div class="col-auto offset-lg-1">
            <img src="@/images/prize.svg" alt="">
          </div>
          <div class="col">
            <div class="result-page__subtitle">3º Lugar</div>
            <div class="result-page__text">VINICIUS AUGUSTO/CAROLINA GREGORIO</div>
            <div class="result-page__small">Tempo Bruto: 00:23:54</div>
            <div class="result-page__small">Tempo Líquido: 00:23:52</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'
import PageHeader from '@/components/PageHeader'
import SearchResults from '@/components/SearchResults'

export default {
  name: 'BannerRegulamento',
  components: {
    PageHeader,
    SearchResults
  },
  data: () => ({
    loading: true,
    f5: [],
    m5: []
  }),
  async created() {
    try {
      let { data: f5 } = await api.results('F5')

      let { data: m5 } = await api.results('M5')

      this.f5 = f5

      this.m5 = m5

    } catch (error) {
      throw error
    } finally {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .result-page
  {
    padding-top: 90px;

    color: #003862;

    &__small
    {
      font-size: 18px;
      font-weight: 300;
    }

    &__title,
    &__subtitle
    {
      font-size: 40px;
      font-weight: bold;
      line-height: 40px;
    }

    &__title,
    &__result
    {
      padding: 30px 0;
    }

    &__text
    {
      font-size: 30px;
      font-weight: 300;
      line-height: 40px;
    }

    &__divider
    {
      height: 1px;
      margin-top: 30px;
      margin-bottom: 60px;

      background-color: #d8d8d8;
    }
  }
</style>
